import { Order } from '@cemex-core/cmx-api';
import { Action } from '@ngrx/store';
import { RecipeFormValues } from '../../models/form-values';

export enum BucketsActionTypes {
  FETCH_BUCKETS = '[Open Platform] Fetch buckets',
  ADD_BUCKETS = '[Open Platform] Add buckets',
  CLEAR_BUCKETS = '[Open Platform] Clear buckets',
  SET_BUCKET = '[Open Platform] Set bucket',
  NO_ACTION = '[Open Platform] No Action buckets',
  LOAD_BUCKETS = '[Open Platform] Load order buckets',
  CONFIRM_BUCKETS = '[Open Platform] Confirm buckets',
  UPDATE_BUCKETS = '[Open Platform] Update buckets',
}

export class FetchBuckets implements Action {
  readonly type = BucketsActionTypes.FETCH_BUCKETS;
  constructor(public payload: { orderFormId: number; orderId: number }) {}
}

export class LoadBuckets implements Action {
  readonly type = BucketsActionTypes.LOAD_BUCKETS;
  constructor(public payload: { orderFormId: number; order: Order }) {}
}

export class AddBuckets implements Action {
  readonly type = BucketsActionTypes.ADD_BUCKETS;
  constructor(public payload: { orderFormId: number; orderId: number; buckets: RecipeFormValues[] }) {}
}

export class ClearBuckets implements Action {
  readonly type = BucketsActionTypes.CLEAR_BUCKETS;
  constructor(public payload: { orderFormId: number }) {}
}

export class NoAction implements Action {
  readonly type = BucketsActionTypes.NO_ACTION;
  constructor() {}
}

export class SetBucketAction implements Action {
  readonly type = BucketsActionTypes.SET_BUCKET;
  constructor(public payload: { bucket: RecipeFormValues; recipe: RecipeFormValues }) {}
}

export class ConfirmBuckets implements Action {
  readonly type = BucketsActionTypes.CONFIRM_BUCKETS;
  constructor(public payload: { orderFormId: number; orderId: number; recipe: RecipeFormValues; clearAll: boolean }) {}
}
export class UpdateBuckets implements Action {
  readonly type = BucketsActionTypes.UPDATE_BUCKETS;
  constructor(public payload: { orderFormId: number; orderId: number; itemId: number }) {}
}
export type BucketActions =
  | FetchBuckets
  | AddBuckets
  | ClearBuckets
  | NoAction
  | SetBucketAction
  | LoadBuckets
  | ConfirmBuckets
  | UpdateBuckets;
